import React from "react";
import { truncateName } from "../utils/customFunction";
import {
  getGridItemStyles,
  getListItemStyles,
  getItemNameStyles,
  getListItemNameStyles,
} from "../styles/styles";
import { FileProps } from "../types/types";
import { useTheme } from "../contexts/ThemeContext";

export const File: React.FC<FileProps> = ({
  name,
  icon,
  isSelected = false,
  viewMode = "grid",
  onContextMenu,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
}) => {
  const { theme } = useTheme();

  if (viewMode === "list") {
    return (
      <div
        style={getListItemStyles(theme, isSelected)}
        onContextMenu={onContextMenu}
        draggable
        onDragStart={onDragStart}
        onDragOver={onDragOver}
        onDrop={onDrop}
        onDragEnd={onDragEnd}
      >
        <img src={icon} alt="File" style={{ width: "24px", height: "24px" }} />
        <span style={getListItemNameStyles(theme)}>{name}</span>
      </div>
    );
  }

  return (
    <div
      style={getGridItemStyles(theme, isSelected)}
      onContextMenu={onContextMenu}
      draggable
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
    >
      <img src={icon} alt="File" />
      <span style={getItemNameStyles(theme)}>{truncateName(name)}</span>
    </div>
  );
};
